(function (global) {
  'use strict';

  var RAD = Math.PI / 180;
  var DAY_MS = 86400000;
  var J1970 = 2440588;
  var J2000 = 2451545;
  var OBLIQUITY = RAD * 23.4397;
  var TWO_PI = Math.PI * 2;
  var SKY_ZENITH_FALLBACK = '#04060D';

  var SKY_PALETTES = {
    day: {
      sky: ['#27486C', '#3E6E97', '#6FA0BF'],
      stars: 0,
    },
    goldenMorning: {
      sky: ['#1C3550', '#6E5B7B', '#DB9A6A'],
      stars: 0,
    },
    goldenEvening: {
      sky: ['#1A2A4A', '#5C4470', '#D97B50'],
      stars: 0,
    },
    twilightMorning: {
      sky: ['#0B1024', '#2A2C55', '#7A5C74'],
      stars: 0.5,
    },
    twilightEvening: {
      sky: ['#070B1E', '#252048', '#8A4E5C'],
      stars: 0.6,
    },
    night: {
      sky: ['#04060D', '#0A1120', '#16233A'],
      stars: 1,
    },
  };

  function normalizeAngle(a) {
    return ((((a + Math.PI) % TWO_PI) + TWO_PI) % TWO_PI) - Math.PI;
  }

  function computeSkyBand(now) {
    now = now || new Date();
    var lng = -now.getTimezoneOffset() / 4;
    var lw = RAD * -lng;
    var phi = RAD * 40;
    var d = now.valueOf() / DAY_MS - 0.5 + J1970 - J2000;
    var m = RAD * (357.5291 + 0.98560028 * d);
    var center =
      RAD * (1.9148 * Math.sin(m) + 0.02 * Math.sin(2 * m) + 0.0003 * Math.sin(3 * m));
    var eclLng = m + center + RAD * 102.9372 + Math.PI;
    var dec = Math.asin(Math.sin(OBLIQUITY) * Math.sin(eclLng));
    var ra = Math.atan2(Math.sin(eclLng) * Math.cos(OBLIQUITY), Math.cos(eclLng));
    var hourAngle = normalizeAngle(RAD * (280.16 + 360.9856235 * d) - lw - ra);
    var altitude = Math.asin(
      Math.sin(phi) * Math.sin(dec) + Math.cos(phi) * Math.cos(dec) * Math.cos(hourAngle),
    );
    var altitudeDeg = (altitude * 180) / Math.PI;
    var isMorning = hourAngle < 0;

    if (altitudeDeg > 5) return 'day';
    if (altitudeDeg > 0) return isMorning ? 'goldenMorning' : 'goldenEvening';
    if (altitudeDeg > -6) return isMorning ? 'twilightMorning' : 'twilightEvening';
    return 'night';
  }

  function skyGradientCss(band) {
    var stops = SKY_PALETTES[band].sky;
    return (
      'linear-gradient(to bottom, ' +
      stops[0] +
      ' 0%, ' +
      stops[1] +
      ' 55%, ' +
      stops[2] +
      ' 100%)'
    );
  }

  function updateThemeColor(zenith) {
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
      meta.setAttribute('content', zenith);
    }
  }

  function buildStars(container, opacity) {
    container.innerHTML = '';
    if (!opacity) {
      container.style.opacity = '0';
      return;
    }

    var chars = ['·', '∙', '⋅', '•'];
    var count = 48;
    for (var i = 0; i < count; i++) {
      var star = document.createElement('span');
      star.className = 'webpunk-sky__star';
      star.textContent = chars[i % chars.length];
      star.style.left = ((i * 37 + 11) % 100) + '%';
      star.style.top = ((i * 53 + 7) % 100) + '%';
      star.style.setProperty('--sky-star-min-o', String(0.15 + (i % 5) * 0.05));
      star.style.setProperty('--sky-star-max-o', String(0.55 + (i % 4) * 0.1));
      star.style.setProperty('--sky-star-dur', 2 + (i % 6) + 's');
      star.style.setProperty('--sky-star-delay', (i % 8) * 0.35 + 's');
      container.appendChild(star);
    }
    container.style.opacity = String(opacity);
  }

  function paintInstant() {
    var band = computeSkyBand();
    var gradient = skyGradientCss(band);
    var zenith = SKY_PALETTES[band].sky[0];
    document.documentElement.style.backgroundColor = zenith;
    if (document.body) {
      document.body.style.backgroundColor = 'transparent';
    }
    updateThemeColor(zenith);
    return { band: band, gradient: gradient, zenith: zenith };
  }

  function ensureSkyRoot() {
    var root = document.getElementById('webpunk-sky');
    if (root) {
      return root;
    }

    root = document.createElement('div');
    root.id = 'webpunk-sky';
    root.className = 'webpunk-sky';
    root.setAttribute('aria-hidden', 'true');

    var back = document.createElement('div');
    back.className = 'webpunk-sky__layer webpunk-sky__layer--back';

    var front = document.createElement('div');
    front.className = 'webpunk-sky__layer webpunk-sky__layer--front';

    var stars = document.createElement('div');
    stars.className = 'webpunk-sky__stars';

    root.appendChild(back);
    root.appendChild(front);
    root.appendChild(stars);
    document.body.insertBefore(root, document.body.firstChild);
    return root;
  }

  function applyBand(band, animate) {
    var root = ensureSkyRoot();
    var back = root.querySelector('.webpunk-sky__layer--back');
    var front = root.querySelector('.webpunk-sky__layer--front');
    var stars = root.querySelector('.webpunk-sky__stars');
    var gradient = skyGradientCss(band);
    var zenith = SKY_PALETTES[band].sky[0];
    var palette = SKY_PALETTES[band];

    document.documentElement.setAttribute('data-sky-band', band);
    document.documentElement.style.backgroundColor = zenith;
    updateThemeColor(zenith);
    buildStars(stars, palette.stars);

    if (!animate || !back.style.backgroundImage) {
      back.style.backgroundImage = gradient;
      front.style.backgroundImage = gradient;
      front.style.opacity = '0';
      return;
    }

    if (back.style.opacity === '0' || !back.style.backgroundImage) {
      back.style.backgroundImage = gradient;
      back.style.opacity = '1';
      front.style.opacity = '0';
      return;
    }

    front.style.backgroundImage = gradient;
    front.style.opacity = '1';
    window.setTimeout(function () {
      back.style.backgroundImage = gradient;
      front.style.opacity = '0';
    }, 2000);
  }

  function refresh(animate) {
    applyBand(computeSkyBand(), animate);
  }

  function init() {
    var instant = paintInstant();
    ensureSkyRoot();
    applyBand(instant.band, false);

    window.setInterval(function () {
      refresh(true);
    }, 60000);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        refresh(true);
      }
    });
  }

  global.webpunkSky = {
    computeSkyBand: computeSkyBand,
    skyGradientCss: skyGradientCss,
    paintInstant: paintInstant,
    SKY_PALETTES: SKY_PALETTES,
    SKY_ZENITH_FALLBACK: SKY_ZENITH_FALLBACK,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(typeof window !== 'undefined' ? window : this);
